const initialState = {
    data: [],
    total: 1,
    params: {},
    allData: []
  }
  
  const invoiceReducerTransacciones = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_DATA_TRANSACCIONES':
        return {
          ...state,
          allData: action.allData,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'DELETE_INVOICE_TRANSACCIONES':
        return { ...state }
      default:
        return { ...state }
    }
  }
  export default invoiceReducerTransacciones
  